export enum NotificationTypeEnum {
  TAGGING = 'TAGGING',
  ASSIGNMENT = 'ASSIGNMENT',
  LOTUS_IMPORT = 'LOTUS_IMPORT',
  PENDING_VALIDATION = 'PENDING_VALIDATION',
  OFFER_REMINDER = 'OFFER_REMINDER'
}
